<template>
  <section>
    <div class="row">
      <div class="col-md-4">
        <span>id:</span>
        <span class="ps-2">{{ id }}</span>
      </div>
      <div class="col-md-4">
        <span>Start:</span>
        <span class="ps-2">{{ start }}</span>
      </div>
      <div class="col-md-4">
        <span>End:</span>
        <span class="ps-2">{{ end }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <span class="custom-progress">Progress</span>
        <span class="ps-2">as of {{ progressDate }}</span>
      </div>
    </div>
    <z-table
      :value="progress"
      sortBy="name"
      orderBy="asc"
      :columns="tableColumns"
      :isSingleRowDetail="false"
      class="table table-bordered table-striped"
      detailColumnClass="z-column-60-center"
    >
      <template v-slot:tbody="props">
        <th scope="row">{{ props.row.name }}</th>
        <td class="z-column-140-center">{{ props.row.weekProgress }}</td>
        <td class="z-column-140-center">{{ props.row.dayProgress }}</td>
        <td class="z-column-140-center">{{ props.row.totalProgress }}</td>
      </template>
      <template v-slot:empty> Nothing found! </template>
    </z-table>
  </section>
</template>
<script>
import moment from 'moment'
import ZTable from '@/Components/ZElements/Table'
export default {
  name: 'challenge-record',
  components: {
    ZTable,
  },
  props: {
    recordData: Object,
  },
  computed: {
    tableColumns() {
      let columns = [
        {
          field: 'name',
          label: 'Name',
          sortable: false,
        },
        {
          field: 'weekProgress',
          label: 'Week Progress',
          sortable: false,
          class: 'z-column-140-center',
        },
        {
          field: 'dayProgress',
          label: 'Daily Progress',
          sortable: false,
          class: 'z-column-140-center',
        },
        {
          field: 'totalProgress',
          label: 'Total Progress',
          sortable: false,
          class: 'z-column-140-center',
        },
      ]
      return columns
    },
    progress() {
      let _data = []
      if (this.recordData) {
        if (this.recordData.subprogress) {
          if (this.recordData.subprogress.length > 0) {
            this.recordData.subprogress.forEach((element) => {
              let desc = ''
              let weekProgress = 0
              let dayProgress = 0
              let totalProgress = 0
              switch (element.rule) {
                case 'GreyZone':
                  desc = 'Grey Zone minutes per week'
                  weekProgress = element.progress_percent
                  break
                case 'BlueZone':
                  desc = 'Blue Zone minutes per week'
                  weekProgress = element.progress_percent
                  break
                case 'OrangeZone':
                  desc = 'Orange Zone minutes per week'
                  weekProgress = element.progress_percent
                  break
                case 'ActiveMinutes':
                  desc = 'Blue & Orange Zone minutes per week'
                  weekProgress = element.progress_percent
                  break
                case 'Program':
                  desc = 'Personal Cardio Program % per week'
                  weekProgress = element.progress_percent
                  break
                case 'SessionCount':
                  desc = 'Sessions per week'
                  weekProgress = element.progress_percent
                  break
                case 'TotalWorkoutMinutes':
                  desc = 'Total minutes per week'
                  weekProgress = element.progress_percent
                  break
                case 'TotalCalories':
                  desc = 'Total calories per week'
                  weekProgress = element.progress_percent
                  break
                case 'FoodTracked':
                  desc = 'Meals tracked per day'
                  dayProgress = element.progress
                  totalProgress = element.progress_percent
                  break
                case 'FoodThumbsUp':
                  desc = 'Thumbs up percent goal'
                  dayProgress = element.progress
                  totalProgress = element.progress_percent
                  break
                case 'WeighInCount':
                  desc = 'Weigh-ins each week'
                  weekProgress = element.progress_percent
                  break
                case 'WeightLoss':
                  desc = 'Weight Loss'
                  totalProgress = element.progress_percent
                  break
                case 'BodyFatLoss':
                  desc = 'Bodyfat % Loss'
                  totalProgress = element.progress_percent
                  break
                case 'ProgressPhotos':
                  desc = 'Progress Photos'
                  totalProgress = element.progress_percent
                  break
                case 'Measurements':
                  desc = 'Measurements'
                  totalProgress = element.progress_percent
                  break
              }
              _data.push({
                name: desc,
                weekProgress: weekProgress
                  ? parseFloat(weekProgress).toFixed(1) + '%'
                  : null,
                dayProgress: dayProgress
                  ? parseFloat(dayProgress).toFixed(1) + '%'
                  : null,
                totalProgress: totalProgress
                  ? parseFloat(totalProgress).toFixed(1) + '%'
                  : null,
              })
            })
          }
        }
      }
      return _data
    },
    id() {
      let _data = null
      if (this.recordData) {
        _data = this.recordData.id
      }
      return _data
    },
    start() {
      let _data = null
      if (this.recordData) {
        _data = moment(this.recordData.startDate).format('MM/DD/YYYY')
      }
      return _data
    },
    end() {
      let _data = null
      if (this.recordData) {
        _data = moment(this.recordData.endDate).format('MM/DD/YYYY')
      }
      return _data
    },
    progressDate() {
      let _data = null
      if (this.recordData) {
        if (this.recordData.progress) {
          _data = moment(this.recordData.progress.progressDate).format(
            'MM/DD/YYYY'
          )
        }
      }
      return _data
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-progress {
  font-weight: 500;
}
</style>
